// extracted by mini-css-extract-plugin
export default {"btn-position":"SearchPageModal_btn-position__PlbUn","modal-body-data":"SearchPageModal_modal-body-data__7Tz+3","cross-icon-position":"SearchPageModal_cross-icon-position__BZd9V"};